// Helpers over the optional mesh bounds the site hands in (assistant never sees three.js).
import type { Bounds } from '../types';

export function centre(b: Bounds): [number, number, number] {
  return [(b[0] + b[3]) / 2, (b[1] + b[4]) / 2, (b[2] + b[5]) / 2];
}

export function union(list: Bounds[]): Bounds | null {
  if (!list.length) return null;
  const out: Bounds = [Infinity, Infinity, Infinity, -Infinity, -Infinity, -Infinity];
  for (const b of list) {
    for (let k = 0; k < 3; k++) {
      if (b[k]! < out[k]!) out[k] = b[k]!;
      if (b[k + 3]! > out[k + 3]!) out[k + 3] = b[k + 3]!;
    }
  }
  return out;
}

export function radius(b: Bounds): number {
  return Math.max(0.5, Math.hypot(b[3] - b[0], b[4] - b[1], b[5] - b[2]) / 2);
}

export function distance(a: Bounds, b: Bounds): number {
  const dx = Math.max(0, a[0] - b[3], b[0] - a[3]);
  const dy = Math.max(0, a[1] - b[4], b[1] - a[4]);
  const dz = Math.max(0, a[2] - b[5], b[2] - a[5]);
  return Math.hypot(dx, dy, dz);
}
